export default "__VITE_ASSET__6f0a24dd__"